const EMAIL_REGEX = /^[A-Za-z0-9_%+-]+(\.[A-Za-z0-9_%+-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,15})$/;

export function validateEmail(email: string) {
    if (!email) {
        return false;
    }

    return EMAIL_REGEX.test(email);
}
